import { Form, Input, Select, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import { Note } from "assets";
import React from "react";

export const optionsReflex = [
  {
    value: "Chọn",
    label: "Chọn",
  },
  {
    value: "Ánh phản xạ sáng",
    label: "Ánh phản xạ sáng",
  },
  {
    value: "Ánh phản xạ tối",
    label: "Ánh phản xạ tối",
  },
  {
    value: "Ánh phản xạ ngoại",
    label: "Ánh phản xạ ngoại",
  },
  {
    value: "Ánh phản xạ trắng",
    label: "Ánh phản xạ trắng",
  },
  {
    value: "Ánh phản xạ trung tâm",
    label: "Ánh phản xạ trung tâm",
  },
];

const optionsDrugUsed = [
  {
    value: "select",
    label: "Chọn",
  },
  {
    value: "tropicamide_P",
    label: "Tropicamide_P",
  },
  {
    value: "tropicamide",
    label: "Tropicamide",
  },
  {
    value: "timolol",
    label: "Timolol",
  },
  {
    value: "homide",
    label: "Homide",
  },
  {
    value: "latanoprost",
    label: "Latanoprost",
  },
  {
    value: "brimonidine",
    label: "Brimonidine",
  },
  {
    value: "travoprost",
    label: "Travoprost",
  },
  {
    value: "tobramycin",
    label: "Tobramycin",
  },
  {
    value: "moxifloxacin",
    label: "Moxifloxacin",
  },
  {
    value: "homatropine",
    label: "Homatropine",
  },
  {
    value: "pilocarpine",
    label: "Pilocarpine",
  },
  {
    value: "cyclopentolate",
    label: "Cyclopentolate",
  },
  {
    value: "atropine",
    label: "Atropine",
  },
  {
    value: "phenylephrine",
    label: "Phenylephrine",
  },
  {
    value: "tropicacyl",
    label: "Tropicacyl",
  },
  {
    value: "paracain",
    label: "Paracain",
  },
  {
    value: "ciplox",
    label: "Ciplox",
  },
  {
    value: "tropicamide_PDistilledWater",
    label: "Tropicamide_P + Distilled Water",
  },
];

const dilatedNetRetinoscopyTb1 = (item, isChoose) => {
  const dilatedNetRetinoscopyTb1: ColumnsType = [
    {
      title: "-",
      dataIndex: "none",
      width: "10%",
    },
    {
      title: "Cầu",
      dataIndex: "sph",
      render: (text: string | number, record: { key: string | number }, i) => {
        return (
          <Form.Item
            name={
              isChoose
                ? ["dilatedNetRetinoscopyDtos", item.name, "tb1", "sph", i]
                : ""
            }
          >
            <Input />
          </Form.Item>
        );
      },
      width: "20%",
    },
    {
      title: "Trụ",
      dataIndex: "cyl",
      render: (text: string | number, record: { key: string | number }, i) => (
        <Form.Item
          name={
            isChoose
              ? ["dilatedNetRetinoscopyDtos", item.name, "tb1", "cyl", i]
              : ""
          }
        >
          <Input />
        </Form.Item>
      ),
      width: "20%",
    },
    {
      title: "Trục",
      dataIndex: "axis",
      render: (
        text: string | number,
        record: { key: string | number },
        index
      ) => (
        <Form.Item
          name={
            isChoose
              ? ["dilatedNetRetinoscopyDtos", item.name, "tb1", "axis", index]
              : ""
          }
        >
          <Input />
        </Form.Item>
      ),
      width: "20%",
    },
    {
      title: "Ánh đồng tử",
      dataIndex: "reflexType",
      render: (text: string | number, record: { key: string | number }, i) => (
        <Form.Item
          name={
            isChoose
              ? ["dilatedNetRetinoscopyDtos", item.name, "tb1", "reflexType", i]
              : ""
          }
        >
          <Select options={optionsReflex} allowClear />
        </Form.Item>
      ),
      width: "30%",
      align: "left",
    },
  ];

  return dilatedNetRetinoscopyTb1;
};

const dilatedNetRetinoscopyTb2 = (item, isChoose) => {
  const dilatedNetRetinoscopyTb2: ColumnsType = [
    {
      title: "name",
      dataIndex: "name",
      render: (text: string | number, record: { key: string | number }) => (
        <Typography>{text}</Typography>
      ),
      width: "31%",
    },
    {
      title: "",
      dataIndex: "",
      align: "left",
      render: (text: string | number, record: { key: string | number }) => {
        if (record.key === 1) {
          return (
            <Form.Item
              name={
                isChoose
                  ? [
                      "dilatedNetRetinoscopyDtos",
                      item.name,
                      "tb2",
                      "atDistance",
                    ]
                  : ""
              }
            >
              <Input suffix="mm" />
            </Form.Item>
          );
        } else if (record.key === 2) {
          return (
            <Form.Item
              name={
                isChoose
                  ? ["dilatedNetRetinoscopyDtos", item.name, "tb2", "drugUsed"]
                  : ""
              }
            >
              <Select options={optionsDrugUsed} allowClear />
            </Form.Item>
          );
        } else
          return (
            <Form.Item
              name={
                isChoose
                  ? ["dilatedNetRetinoscopyDtos", item.name, "tb2", "comments"]
                  : ""
              }
            >
              <Input.TextArea
                style={{
                  minHeight: "fit-content",
                  boxShadow: "none",
                  border: "none",
                }}
                autoSize
                rows={2}
              />
            </Form.Item>
          );
      },
      width: "69%",
    },
  ];
  return dilatedNetRetinoscopyTb2;
};

export { dilatedNetRetinoscopyTb1, dilatedNetRetinoscopyTb2 };
